import React, { useState } from "react";
import "../../styles/landing/BentoGrid.css";
import { 
  FiCamera, 
  FiLayers, 
  FiShield, 
  FiCheck,
  FiDownloadCloud
} from "react-icons/fi";
import { FaQrcode } from "react-icons/fa";

const BentoGrid = () => {
  const [isFanned, setIsFanned] = useState(false);

  return (
    <section className="foto-showcase-section" id="features">
      <div className="foto-showcase-container">
        
        {/* Clean Header */}
        <div className="showcase-header">
          <span className="showcase-eyebrow">Smart Photo Delivery</span>
          <h2 className="showcase-title">
            Find and Share Wedding Photos <span className="title-highlight">Effortlessly</span>
          </h2>
          <div className="highlight-line4"></div>
          <p className="showcase-subtitle">
            No more hunting through thousands of drive photos. One selfie instantly collects all your moments in original studio quality.
          </p>
        </div>

        {/* Two Main Visual Showcases Out in the Open */}
        <div className="showcase-duo-grid">
          
          {/* SHOWCASE 1: Real Photo Face Recognition */}
          <div className="showcase-card showcase-face-scan">
            <div className="showcase-card-header">
              <span className="showcase-badge">
                <FiCamera className="badge-icon" /> Instant Face Match
              </span>
              <span className="showcase-subtag">1-Tap Discovery</span>
            </div>

            <h3 className="card-headline">Take a selfie. Get all your photos.</h3>
            <p className="card-subtext">
              Our intelligent face finder scans the entire event album in seconds, grouping every candid and stage shot of you automatically.
            </p>

            {/* Individual Photo Scan Visual (Spacious & Clean) */}
            <div className="photo-scan-display">
              <div className="photo-scan-frame">
                <img 
                  src="/image/13.jpg" 
                  alt="Wedding Couple" 
                  className="scanned-wedding-photo"
                />
                
                {/* Subtle Scan Beam */}
                <div className="photo-scan-line"></div>

                {/* Clean Face Detection Overlay */}
                <div className="face-scan-box">
                  <div className="scan-box-corner tl"></div>
                  <div className="scan-box-corner tr"></div>
                  <div className="scan-box-corner bl"></div>
                  <div className="scan-box-corner br"></div>
                  <div className="face-detected-tag">
                    <span className="detected-dot"></span>
                    <span>Priya &amp; Rahul</span>
                  </div>
                </div>

                {/* Floating Clean Result Pill */}
                <div className="photo-scan-result-pill">
                  <FiCheck className="pill-check" />
                  <span>42 Photos Found of You</span>
                </div>
              </div>
            </div>
          </div>

          {/* SHOWCASE 2: Interactive 3D Ceremony Photo Deck */}
          <div 
            className="showcase-card showcase-photo-deck"
            onMouseEnter={() => setIsFanned(true)}
            onMouseLeave={() => setIsFanned(false)}
            onClick={() => setIsFanned(!isFanned)}
          >
            <div className="showcase-card-header">
              <span className="showcase-badge badge-deck">
                <FiLayers className="badge-icon" /> Ceremony Stacks
              </span>
              <span className="showcase-hint">Hover to open cards</span>
            </div>

            <h3 className="card-headline">Organized by Every Ritual</h3>
            <p className="card-subtext">
              Albums are categorized by moments — from Haldi and Varmala to the Reception party, perfectly arranged for guests.
            </p>

            {/* Open 3D Photo Deck (Natural & Clean) */}
            <div className={`clean-stack-container ${isFanned ? "is-open" : ""}`}>
              <div className="clean-stack-card card-left">
                <img src="/image/14.jpg" alt="Varmala Ceremony" />
                <div className="clean-stack-caption">Varmala Moments</div>
              </div>

              <div className="clean-stack-card card-center">
                <img src="/image/13.jpg" alt="Highlight Couple Shot" />
                <div className="clean-stack-caption center-caption">Couple Highlights</div>
              </div>

              <div className="clean-stack-card card-right">
                <img src="/image/hello.jpg" alt="Family & Friends" />
                <div className="clean-stack-caption">Family &amp; Candids</div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom 3 Clean Benefit Pillars */}
        <div className="showcase-pillars-row">
          
          {/* Pillar 1: Table QR */}
          <div className="pillar-item">
            <div className="pillar-icon-box icon-qr">
              <FaQrcode />
            </div>
            <div className="pillar-text">
              <h4 className="pillar-title">Tabletop QR Access</h4>
              <p className="pillar-desc">
                Guests simply scan the table standee to browse their photos. Zero app downloads needed.
              </p>
            </div>
          </div>

          {/* Pillar 2: 4K Original Quality */}
          <div className="pillar-item">
            <div className="pillar-icon-box icon-quality">
              <FiDownloadCloud />
            </div>
            <div className="pillar-text">
              <h4 className="pillar-title">Original 4K Quality</h4>
              <p className="pillar-desc">
                Preserve full studio resolution, bitrates, and camera colors without any compression.
              </p>
            </div>
          </div>

          {/* Pillar 3: Privacy */}
          <div className="pillar-item">
            <div className="pillar-icon-box icon-privacy">
              <FiShield />
            </div>
            <div className="pillar-text">
              <h4 className="pillar-title">Private &amp; Secure</h4>
              <p className="pillar-desc">
                Guests only see photos they appear in. Family and private folders stay protected.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default BentoGrid;
